import { render, staticRenderFns } from "./GideEventView.vue?vue&type=template&id=1bea02b2&scoped=true"
import script from "./GideEventView.vue?vue&type=script&lang=js"
export * from "./GideEventView.vue?vue&type=script&lang=js"
import style0 from "./GideEventView.vue?vue&type=style&index=0&id=1bea02b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea02b2",
  null
  
)

export default component.exports